import { ApolloClient, InMemoryCache } from "@apollo/client";
import { CREATE_AGENT_MUTATION } from "../mutations/createAgentMutation";
import { UPDATE_AGENT_MUTATION } from "../mutations/updateAgentMutation";
import { DELETE_AGENT_MUTATION } from "../mutations/deleteAgentMutation";
import { GET_AGENT_QUERY } from "../queries/getAgentQuery";
import { INTERACT_WITH_AGENT_MUTATION } from "../mutations/interactWithAgentMutation";

const GRAPHQL_ENDPOINT =
  "https://7mhsf3i4araejpsvxwdidrca3i.appsync-api.us-east-1.amazonaws.com/graphql"; // Replace with your GraphQL endpoint URL

// Initialize Apollo Client
export const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-7qpyhpym6rflvobktvglsdrepe", // Replace with your actual API key
  },
});

// API call to create a new agent configuration
export const createAgentApi = async (input) => {
  console.log(
    `PMM - SF - agentApi.js - createAgentApi - input is: ${JSON.stringify(
      input
    )}`
  );

  const apiPayload = {
    mutation: CREATE_AGENT_MUTATION,
    variables: { input },
  };

  console.log(
    `PMM - SF - agentApi.js - createAgentApi - apiPayload is: ${JSON.stringify(
      apiPayload
    )}`
  );

  try {
    const response = await client.mutate(apiPayload);
    // const response = await client.mutate({
    //   mutation: CREATE_AGENT_MUTATION,
    //   variables: { input: agentInput },
    // });

    return response.data.createAgent;
  } catch (error) {
    console.error(`Error creating agent: ${error.message}`);
    throw error;
  }
};

// API call to update an existing agent configuration
export const updateAgentApi = async (agentInput) => {
  console.log(
    `Agent API - updateAgentApi - agentInput: ${JSON.stringify(agentInput)}`
  );

  try {
    const response = await client.mutate({
      mutation: UPDATE_AGENT_MUTATION,
      variables: { input: agentInput },
    });

    return response.data.updateAgent;
  } catch (error) {
    console.error(`Error updating agent: ${error.message}`);
    throw error;
  }
};

// API call to delete an agent configuration
export const deleteAgentApi = async (deleteAgentInput) => {
  console.log(
    `Agent API - deleteAgentApi - deleteAgentInput: ${JSON.stringify(
      deleteAgentInput
    )}`
  );

  try {
    const response = await client.mutate({
      mutation: DELETE_AGENT_MUTATION,
      variables: { input: deleteAgentInput },
    });

    return response.data.deleteAgent;
  } catch (error) {
    console.error(`Error deleting agent: ${error.message}`);
    throw error;
  }
};

// API call to retrieve an agent configuration
export const getAgentApi = async (tenantId, agentId) => {
  console.log(
    `Agent API - getAgentApi - tenantId: ${tenantId}, agentId: ${agentId}`
  );

  try {
    const response = await client.query({
      query: GET_AGENT_QUERY,
      variables: { tenantId, agentId },
      fetchPolicy: "network-only", // Ensures fresh data on each query
    });

    return response.data.getAgent;
  } catch (error) {
    console.error(`Error fetching agent: ${error.message}`);
    throw error;
  }
};

// API call to interact with an agent
export const interactWithAgentApi = async (interactionInput) => {
  console.log(
    `Agent API - interactWithAgentApi - input: ${JSON.stringify(
      interactionInput
    )}`
  );

  try {
    const response = await client.mutate({
      mutation: INTERACT_WITH_AGENT_MUTATION,
      variables: { input: interactionInput },
    });

    console.log(
      `PMM - SF - agentApi - response is: ${JSON.stringify(response)}`
    );
    console.log(
      `PMM - SF - agentApi - response.data.interactWithAgent is: ${JSON.stringify(
        response.data.interactWithAgent
      )}`
    );
    return response.data.interactWithAgent;
  } catch (error) {
    console.error(`Error interacting with agent: ${error.message}`);
    throw error;
  }
};
